import { render } from "./footer.vue?vue&type=template&id=3c3d00ed&scoped=true"
const script = {}

import "./footer.vue?vue&type=style&index=0&id=3c3d00ed&lang=less&scoped=true"

import exportComponent from "/workspace/hzjt-cms-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c3d00ed"]])

export default __exports__